import { Order } from 'effect';

const collator = new Intl.Collator('cs');

/**
 * Czech alphabetical order: `č` follows `c`, `š` follows `s`, `ž` follows `z`,
 * `ř` follows `r`, and accented vowels sit beside the letter they accent.
 * Comparing codepoints instead exiles every one of them past `z`.
 */
export const czechStringOrder = Order.make<string>((a, b) => {
  const result = collator.compare(a, b);
  return result < 0 ? -1 : result > 0 ? 1 : 0;
});
